import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ProfileDetails = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(
          `https://shubhjiwan.co.in/ShubhJiwan_backend11/fetch_profile.php?id=${id}`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch profile.");
        }

        const data = await response.json();
        console.log("API Response:", data);

        if (data.profiles && data.profiles.length > 0) {
          setProfile(data.profiles[0]);
        } else {
          setError("No profile found.");
        }
      } catch (error) {
        console.error("Fetch error:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id]);

  if (loading) return <p className="text-center mt-10">Loading...</p>;
  if (error) return <p className="text-center text-red-500 mt-10">{error}</p>;
  if (!profile) return <p className="text-center mt-10">No profile data available.</p>;

  return (
    <>
      <Navbar />

      <div className="bg-gray-100 min-h-screen py-10 px-4">
        <div className="max-w-6xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
          {/* Profile Header */}
          <div className="relative bg-gradient-to-r from-pink-500 to-purple-500 h-72">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center text-white">
                <h1 className="text-4xl font-bold mt-10">{profile.name}</h1>
                <p className="text-lg mt-2">Perfect</p>
                <span className="inline-flex items-center px-3 py-1 bg-green-600 text-white rounded-full text-sm mt-2">
                  <span className="mr-2 w-2 h-2 bg-green-400 rounded-full"></span>
                  Online Now
                </span>
              </div>
            </div>
            <img
  src={profile.photo || "/assets/Landing-Background.jpg"}
  alt="Profile"
  className="absolute bottom-[-10px] sm:bottom-[-20px] md:bottom-[-30px] object-cover left-4 sm:left-6 md:left-8 w-28 h-28 sm:w-40 sm:h-40 md:w-60 md:h-60 rounded-full border-4 border-white shadow-md"
/>

          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-between items-center mt-10 sm:mt-16 px-4 sm:px-8 space-y-4 sm:space-y-0">
            <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0 w-full sm:w-auto">
              <button
                className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 hover:shadow-lg transition w-full sm:w-auto"
                onClick={() => {
                  const userData = {
                    id: profile.id,
                    name: profile.name,
                    profile_image: profile.photo
                  };
                  localStorage.setItem("selectedUser", JSON.stringify(userData));
                  window.dispatchEvent(new Event("openChatBox"));
                }}
              >
                Message Me
              </button>

              <button
                className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 hover:shadow-lg transition w-full sm:w-auto"
                onClick={() => navigate("/profiles")}
              >
                More Profiles
              </button>
            </div>
          </div>

          {/* Profile Details */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 px-8 py-6">
  {/* Details */}
  <div className="text-left">
    <h2 className="text-xl font-semibold mb-4">Details</h2>
    <ul className="space-y-2 text-gray-600">
      <li>
        Age: <span className="font-medium">{profile.age}</span>
      </li>
      <li>
        Height: <span className="font-medium">{profile.height}</span>
      </li>
      <li>
        City: <span className="font-medium">{profile.city}</span>
      </li>
      <li>
        Education: <span className="font-medium">{profile.education}</span>
      </li>
      <li>
        Profession: <span className="font-medium">{profile.occupation}</span>
      </li>
      <li>
        Annual Income: <span className="font-medium">{profile.annual_income}</span>
      </li>
      <li>
        Gender: <span className="font-medium">{profile.gender}</span>
      </li>
      <li>
        Religion: <span className="font-medium">{profile.religion}</span>
      </li>
      <li>
        Caste: <span className="font-medium">{profile.caste}</span>
      </li>
      <li>
        Marital Status: <span className="font-medium">{profile.marital_status}</span>
      </li>
    </ul>
  </div>

  {/* About Me */}
  <div className="text-left">
    <h2 className="text-xl font-semibold mb-4">About Me</h2>
    <p className="text-gray-600 mb-4 leading-relaxed">
      {profile.about}
    </p>
  </div>

  {/* I'm Looking For */}
  <div className="text-left">
    <h2 className="text-xl font-semibold mb-4">I'm Looking For</h2>
    <p className="text-gray-600 mb-4 leading-relaxed">
      {profile.looking_for}
    </p>
  </div>
</div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default ProfileDetails;
